import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Delivery, DeliveryPaymentStatus, DeliveryPaymentStatusAux, DeliveryStatus, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { Expert } from 'src/app/models/expert.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { ExpertSalaryService } from 'src/app/services/expert-salary.service';
import { ExpertService } from 'src/app/services/expert.service';
import { PaginationComponent } from '../_pagination/pagination.component';
import { Service } from 'src/app/services/service.service';
import { ServiceModel } from 'src/app/models/service.schems';
import { MatDialog } from '@angular/material/dialog';
import { ExpertSalaryDialogComponent } from '../expert-salary-dialog/expert-salary-dialog.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { SalaryClaimPopUpComponent } from '../salary-claim-pop-up/salary-claim-pop-up.component';
import { RefundRequestComponent } from '../refund-request/refund-request.component';
import { RefundRequestsService } from 'src/app/services/refund-requests.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { RefundRequest } from 'src/app/models/refund-request.schema';
import { ShowInfoModalComponent } from '../show-info-modal/show-info-modal.component';
import { DeliveryService } from 'src/app/services/delivery.service';
import { TransactionsService } from 'src/app/services/transactions.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-expert-salary',
  templateUrl: './expert-salary.component.html',
  styleUrls: ['./expert-salary.component.scss']
})
export class ExpertSalaryComponent implements OnInit {

  groups: any;
  limit: number;
  page: number;
  count: number = 0;
  maxPage: number;
  order: {};
  selected = "";
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'Delivery.deliveryDate': 'DESC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
  filtered = {};
  today: any;
  experts: Expert[];
  selectedDeliveries: Delivery[] = [];
  deliveries: Delivery[] = [];
  selectedExpert: any;
  selectedExpertId: any = null;
  _deliveryFilterForm;
  deliveryStatusAux = DeliveryStatusAux;
  deliveryPaymentStatusAux = DeliveryPaymentStatusAux;
  services: ServiceModel[] = [];
  expertDialogOpen: number;

  settings = {
    active: {
      title: "Stipendi",
    },
    inactive: {
      title: "Storico Stipendi",
    }
  };

  private readonly tableSpacing = {
    admin: {
      id: 5,
      deliveryDate: 10,
      time: 10,
      partner: 15,
      expert: 10,
      address: 30,
      status: 5,
      detail: 5,
      edit: 5,
      assignExpert: 5,
      historyStatus: 5,
    },
    partner: {
      id: 5,
      deliveryDate: 10,
      time: 10,
      address: 20,
      status: 5,
      detail: 10,
      edit: 10,
      historyStatus: 5,
    },
    expert: {
      id: 5,
      deliveryDate: 10,
      time: 15,
      partner: 10,
      address: 20,
      status: 10,
      edit: 20,
      detail: 10,
      historyStatus: 5,
    },
  };
  disableBtn: boolean = false;
  @ViewChild(PaginationComponent, { static: false }) paginationComponent: PaginationComponent;
  grandTotalValues: {
    refundPlus: 0,
    prezzo: 0,
    plusMinusPrezzo: 0,
    valetSalary: 0,
    valetPlusMinusSalary: 0,
    payAtDeliveryAmount: 0,
    totale: 0,
  }
  showAddionalPriceValetModal: boolean = false;
  selectedDelivery: Delivery;
  additionalValetPlusMinus: number = 0;
  isSubmitting: boolean = false;

  constructor(
    private authStatusService: AuthStatusService,
    private expertService: ExpertService,
    private route: ActivatedRoute,
    private expertSalaryService: ExpertSalaryService,
    private _snackBar: MatSnackBar,
    private router: Router,
    public service: Service,
    public dialog: MatDialog,
    public spinnerService: SpinnerService,
    public refundRequestsService: RefundRequestsService,
    public commanUsesService: CommanUsesService,
    private deliveriesService: DeliveryService,
    private transactionsService: TransactionsService,
  ) {
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      if(this.groups.includes('expert')){
        let loggedInExpert = JSON.parse(sessionStorage.getItem("currentUser"));
        this.selectedExpert = await this.expertService.getOne(loggedInExpert?.expert?.id);
      }
      this.handleFilterForm();
      var today = new Date();
      var tmptoday = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
      this.today = tmptoday;
      this.expertDialogOpen = 0;
      this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
      await this.filter();
      await this.initialize();
      this.spinnerService.hide();
    } catch (error) {
      this.showSnackBar("Something went wrong on this page");
    }
  }

  async initialize(){
    if(this.groups.includes('admin') || this.groups.includes('operation')){
      await this.getAllExperts();
    }
    await this.getAllService();
    // try {
    //   this.experts = (await this.expertService.getAllActiveExperts(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' })).experts;
    // }
    // catch { }
  }

  async getAllService(){
    try {
      const services = await this.service.getAllServicess();
      this.services = services.services;
    }
    catch { }
  }

  async getAllExperts(){
    try {
      // this.experts = (await this.expertService.getAllActiveExperts(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' })).experts;
      this.experts = await this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts);
    }
    catch { }
  }

  public groupWhitelisted(groups: string | string[]): boolean {
    if (!Array.isArray(groups))
      return this.groups.includes(groups);
    for (let group of groups)
      if (this.groups.includes(group))
        return true;
    return false;
  }

  handleFilterForm(){
    this._deliveryFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(''),
      'Delivery.deliveryDate_to': new FormControl(''),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.partner.address': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.price': new FormControl(''),
      'Service.pricingModel': new FormControl(''),
      'Service.serviceName': new FormControl(''),
      'Delivery.invoiced': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.payable': new FormControl(''),
      'Delivery.expertSalary': new FormControl(''),
      'Delivery.valetAdditionalPrice': new FormControl(''),
      'Delivery.additionalPrice': new FormControl(''),
      'Delivery.orderId': new FormControl(''),
      'RefundRequests.createdFrom': new FormControl(''),
      'RefundRequests.createdTo': new FormControl(''),
      'RefundRequests.createdAt': new FormControl(''),
      'RefundRequests.plusValue': new FormControl(''),
      'Delivery.payAtDeliveryAmount': new FormControl(''),
      'Delivery.ddtNumber': new FormControl(''),
      'Delivery.paymentStatus': new FormControl(''),
    });
  }

  async fnReset() {
    this._deliveryFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(),
      'Delivery.deliveryDate_to': new FormControl(),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.receiverPhone': new FormControl(''),
      'Delivery.deliveryDate': new FormControl(''),
      'Delivery.time': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.partner.address': new FormControl(''),
      'Delivery.price': new FormControl(''),
      'Service.pricingModel': new FormControl(''),
      'Service.serviceName': new FormControl(''),
      'Delivery.invoiced': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.payable': new FormControl(''),
      'Delivery.expertSalary': new FormControl(''),
      'Delivery.valetAdditionalPrice': new FormControl(''),
      'Delivery.additionalPrice': new FormControl(''),
      'Delivery.orderId': new FormControl(''),
      'RefundRequests.createdFrom': new FormControl(''),
      'RefundRequests.createdTo': new FormControl(''),
      'RefundRequests.createdAt': new FormControl(''),
      'RefundRequests.plusValue': new FormControl(''),
      'Delivery.payAtDeliveryAmount': new FormControl(''),
      'Delivery.ddtNumber': new FormControl(''),
      'Delivery.paymentStatus': new FormControl(''),
    });
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    this.expertDialogOpen = 0;
    this.deliveries = [];
    this.count = 0;
    this.selectedExpert = null;
    this.selectedExpertId = null;
  }

  async filter() {

    let filterForm = (new FormGroupToObject()).transform(this._deliveryFilterForm);
    this.filtered = {};

    if (filterForm['Delivery.id'])
      this.filtered['Delivery.id'] = filterForm['Delivery.id'];
    if (filterForm['Delivery.deliveryDate_from'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.deliveryDate_from']] };
    if (filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'lessThan', values: [filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.deliveryDate_from'] && filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'between', values: [filterForm['Delivery.deliveryDate_from'], filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.fromTime'])
      this.filtered['Delivery.fromTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.fromTime']] };
    if (filterForm['Delivery.toTime'])
      this.filtered['Delivery.toTime'] = { operator: 'lessThan', values: [filterForm['Delivery.toTime']] };
    if (filterForm['Delivery.pickUpTime'])
      this.filtered['Delivery.pickUpTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.pickUpTime']] };
    if (filterForm['Delivery.status'])
      this.filtered['Delivery.status'] = filterForm['Delivery.status'];
    if (filterForm['Delivery.paymentStatus'])
      this.filtered['Delivery.paymentStatus'] = filterForm['Delivery.paymentStatus'];
    if (filterForm['Delivery.address'])
       this.filtered['Delivery.address'] = { operator: 'like', values: [`%${filterForm['Delivery.address']}%`]};
      this.filtered['Delivery.receiverPhone'] = filterForm['Delivery.receiverPhone'];
    if (filterForm['Delivery.deliveryDate'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'like', values: [`%${filterForm['Delivery.deliveryDate']}%`] };
    if (filterForm['Delivery.time'])
      this.filtered['Delivery.time'] = { operator: 'like', values: [`%${filterForm['Delivery.time']}%`] };
    if (filterForm['Partner.businessName'])
      this.filtered['Partner.businessName'] = { operator: 'like', values: [`%${filterForm['Partner.businessName']}%`] };
    if (filterForm['UserExpert.surname'])
      this.filtered['UserExpert.surname'] = { operator: 'like', values: [`%${filterForm['UserExpert.surname']}%`], concat: [{ string: ' ' }, { column: 'UserExpert.name' }] };
    if (filterForm['Delivery.address'])
      this.filtered['Delivery.address'] = { operator: 'like', values: [`%${filterForm['Delivery.address']}%`]};
    if (filterForm['Service.serviceName'])
      this.filtered['Service.serviceName'] = { operator: 'like', values: [`%${filterForm['Service.serviceName']}%`]};
    if (filterForm['Service.pricingModel'])
      this.filtered['Service.pricingModel'] = { operator: 'like', values: [`%${filterForm['Service.pricingModel']}%`]};
    if (filterForm['Delivery.partner.address'])
      this.filtered['Delivery.partner.address'] = { operator: 'like', values: [`%${filterForm['Delivery.partner.address']}%`], concat: [{ string: ' ' }, { column: 'Delivery.partner.address' }] };
    if (filterForm['Delivery.price'])
      this.filtered['Delivery.price'] = { operator: 'like', values: [`%${filterForm['Delivery.price']}%`]};
    if (filterForm['Delivery.serviceType'])
      this.filtered['Delivery.serviceType'] = { operator: 'like', values: [`%${filterForm['Delivery.serviceType']}%`]};
    if (filterForm['Delivery.billable'])
      this.filtered['Delivery.billable'] = { operator: 'like', values: [`%${filterForm['Delivery.billable']}%`]};
    if (filterForm['Delivery.payable'])
      this.filtered['Delivery.payable'] = { operator: 'like', values: [`%${filterForm['Delivery.payable']}%`]};
    if (filterForm['Delivery.expertSalary'])
      this.filtered['Delivery.expertSalary'] = { operator: 'like', values: [`%${filterForm['Delivery.expertSalary']}%`]};
    if (filterForm['Delivery.valetAdditionalPrice'])
      this.filtered['Delivery.valetAdditionalPrice'] = { operator: 'like', values: [`%${filterForm['Delivery.valetAdditionalPrice']}%`]};
    if (filterForm['Delivery.additionalPrice'])
      this.filtered['Delivery.additionalPrice'] = { operator: 'like', values: [`%${filterForm['Delivery.additionalPrice']}%`]};
    if (filterForm['Delivery.orderId'])
      this.filtered['Delivery.orderId'] = { operator: 'like', values: [`%${filterForm['Delivery.orderId']}%`]};
    if (filterForm['Delivery.payAtDeliveryAmount'])
      this.filtered['Delivery.payAtDeliveryAmount'] = { operator: 'like', values: [`%${filterForm['Delivery.payAtDeliveryAmount']}%`]};

    /* Refund Request Filters */
    if (filterForm['RefundRequests.createdFrom'] && filterForm['RefundRequests.createdTo']) {
      const fromDate = filterForm['RefundRequests.createdFrom'];
      const toDate = filterForm['RefundRequests.createdTo'];
      const start = `${fromDate} 00:00:00`;
      const end = `${toDate} 23:59:59.999`;

      this.filtered['RefundRequests.createdAt'] = {
        operator: 'between',
        values: [start, end],
      };
    } else if (filterForm['RefundRequests.createdFrom']) {
      const start = `${filterForm['RefundRequests.createdFrom']} 00:00:00`;
      this.filtered['RefundRequests.createdAt'] = {
        operator: 'moreThanOrEqual',
        values: [start],
      };
    } else if (filterForm['RefundRequests.createdTo']) {
      const end = `${filterForm['RefundRequests.createdTo']} 23:59:59.999`;
      this.filtered['RefundRequests.createdAt'] = {
        operator: 'lessThanOrEqual',
        values: [end],
      };
    } else if (filterForm['RefundRequests.createdDate']) {
      this.filtered['RefundRequests.createdAt'] = {
        operator: 'like',
        values: [filterForm['RefundRequests.createdDate'] + '%'],
      };
    }
    if (filterForm['RefundRequests.plusValue']) {
      this.filtered['RefundRequests.plusValue'] = { operator: 'like', values: [`%${filterForm['RefundRequests.plusValue']}%`]};
    }

    if (filterForm['Delivery.ddtNumber']) {
      this.filtered['Delivery.ddtNumber'] = {
        operator: 'like',
        values: [`%${filterForm['Delivery.ddtNumber']}%`]
      };
    }
    /* Refund Request Filters */
    await this.loadDeliveries();
  }

  async loadDeliveries(limit?: number, page?: number, order?: {}) {
    let filterForm = (new FormGroupToObject()).transform(this._deliveryFilterForm);
    if(filterForm['Delivery.deliveryDate_to'] && filterForm['Delivery.deliveryDate_from']){
      if((this.today != filterForm['Delivery.deliveryDate_from'])){
        this.defaultOrder = { 'Delivery.deliveryDate': 'ASC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
      }
    }

    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;

    let deliveries: any;
    if(this.selected == 'active'){
      this.filtered['Delivery.sendToExpert'] = { operator: 'equal', values: [0]};
      deliveries = await this.expertSalaryService.getAllDeliveries(this.selectedExpert?.id, this.page, this.limit, this.order, this.filtered);
    } else {
      this.filtered['Delivery.sendToExpert'] = { operator: 'equal', values: [1]};
      deliveries = await this.expertSalaryService.getAllDeliveries(this.selectedExpert?.id, this.page, this.limit, this.order, this.filtered);
    }
    this.deliveries = deliveries.deliveries;
    this.count = deliveries.count;
    this.maxPage = Math.ceil(this.count / this.limit);
    this.generateGrandTotalValues();
  }

  public getSpacing(property) {
    if (this.groups.includes('expert'))
      return this.tableSpacing['expert'][property] || 0;
    if (this.groups.includes('partner'))
      return this.tableSpacing['partner'][property] || 0;
    if (this.groups.includes('admin'))
      return this.tableSpacing['admin'][property] || 0;
  }

  navigate(event) {
    this.loadDeliveries(event.limit, event.page, this.order);
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            return 'fa-sort-up';
          case 'DESC':
            return 'fa-sort-down';
          default:
            return 'fa-sort';
        }
      }
    }
  }

  public navigateOrder(attribute: string | string[]) {
    if(this.order){
      delete this.order['Delivery.updatedAt'];
    }
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            this.order[attr] = 'DESC';
            break;
          case 'DESC':
            this.order[attr] = undefined;
            break;
          default:
            this.order = {}
            this.order[attr] = 'ASC';
            break;
        }
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  snack(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(data => {
      this.loadDeliveries();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }


  formatTimeShow(fromTime, toTime){
    let trimmedFromTime = fromTime != null ? fromTime?.slice(0, -3) : '';
    let trimmedToTime = toTime != null ? toTime?.slice(0, -3) : '';
    let time = trimmedFromTime + '-' + trimmedToTime;
    return time;
  }

  isSelected(delivery: any): boolean {
    return this.selectedDeliveries.includes(delivery);
  }

  toggleSelection(delivery: any) {
    if (this.isSelected(delivery)) {
        this.selectedDeliveries = this.selectedDeliveries.filter(item => item !== delivery);
    } else {
        this.selectedDeliveries.push(delivery);
    }
  }

  selectAllDeliveries() {
    const allDeliveriesSelected = this.selectedDeliveries.length === this.deliveries.length;
    this.selectedDeliveries = allDeliveriesSelected ? [] : [...this.deliveries];
  }

  showServiceDetails(serviceId: number){
    if(serviceId){
      const service = this.services.find((service) => service.id == serviceId);
      return service;
    }
  }

  async handleExpertChange(expertId: any){
    try {
      this.spinnerService.show();
      this.selectedDeliveries = [];
      this.selectedExpert = this.experts.find((expert) => {
        return expert?.id == expertId;
      });
      this.selectedExpertId = this.selectedExpert?.id;
      await this.loadDeliveries();
      this.spinnerService.hide();
    } catch (error) {
      this.showSnackBar("Something went wrong fetching details of selected valet");
    }
  }

  expertSalaryModel(){
    if(this.selectedExpert === null || this.selectedExpert == undefined ){
      alert('Please select valet first');
      return false;
    }

    let ref = this.dialog.open(ExpertSalaryDialogComponent, {maxWidth: '95%', data: {
      deliveries: this.selectedDeliveries,
      expert: this.selectedExpert,
      historyPage: this.selected
    } });
    ref.afterClosed().subscribe(async (result) => {
      if(result?.success){
        this.deliveries = this.deliveries.filter(
          d => !this.selectedDeliveries.includes(d)
        );
        this.count = this.deliveries.length;
        // this.selectedDeliveries = [];
        // this.expertDialogOpen = 0;
        // this.selectedExpert = null;
        // this.selectedExpertId = null;
        // await this.loadDeliveries();
      }
    });
  }

  async complainForDeliverySalary(delivery: Delivery) {
    try {
      this.disableBtn = true;
      let ref = this.dialog.open(SalaryClaimPopUpComponent, { width: '50vw', data: { delivery } });
      ref.afterClosed().subscribe(async (result) => {});
      this.disableBtn = false;
    } catch (error) {
      console.log("ERROR", error);
      this.disableBtn = false;
    }
  }

  async requestSalaryRefund(delivery: Delivery) {
    try {
      this.disableBtn = true;
      let ref = this.dialog.open(RefundRequestComponent, { width: '50vw', data: { delivery } });
      ref.afterClosed().subscribe(async (result) => {
        if(result) {
          await this.loadDeliveries();
        }
      });
      this.disableBtn = false;
    } catch (error) {
      console.log("ERROR", error?.message);
      this.disableBtn = false;
    }
  }

  showSnackBar(message: string){
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  commanForValues(delivery: Delivery) {

    let totals = {
      refundPlus: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valetSalary: 0,
      valetPlusMinusSalary: 0,
      payAtDeliveryAmount: 0,
      totale: 0,
      extraAddionalPlusMinusAmount: 0,
    }

    if(!delivery.payable && !delivery?.refundRequest) {
      return totals;
    }

    const extraAddionalPlusMinusAmount  = Number(delivery?.additionalValetPlusMinus ?? 0);

    totals.refundPlus = delivery?.refundRequest?.requestStatus === 'approved' ? Number(delivery?.refundRequest?.plusValue ?? 0) : 0;
    totals.prezzo = Number(delivery?.price) || 0;
    totals.plusMinusPrezzo = (Number(delivery?.additionalPrice) || 0);
    totals.valetSalary = Number(delivery?.expertSalary) || 0;
    totals.valetPlusMinusSalary = Number(delivery?.valetAdditionalPrice) || 0;
    totals.payAtDeliveryAmount = Number(delivery?.payAtDeliveryAmount) || 0;
    totals.extraAddionalPlusMinusAmount = Number(extraAddionalPlusMinusAmount) || 0;
    totals.totale = (totals.valetSalary + totals.valetPlusMinusSalary + totals.extraAddionalPlusMinusAmount + totals.refundPlus) - totals.payAtDeliveryAmount;
    return totals;

  }

  generateGrandTotalValues(){
    this.grandTotalValues = {
      refundPlus: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valetSalary: 0,
      valetPlusMinusSalary: 0,
      payAtDeliveryAmount: 0,
      totale: 0,
    }

    this.deliveries.forEach((delivery) => {
      const values = this.commanForValues(delivery);
      this.grandTotalValues.refundPlus += values.refundPlus;
      this.grandTotalValues.prezzo += values.prezzo;
      this.grandTotalValues.plusMinusPrezzo += values.plusMinusPrezzo;
      this.grandTotalValues.valetSalary += values.valetSalary;
      this.grandTotalValues.valetPlusMinusSalary += values.valetPlusMinusSalary;
      this.grandTotalValues.payAtDeliveryAmount += values.payAtDeliveryAmount;
      this.grandTotalValues.totale += values.totale;
      if(delivery.payable) {
      }
    });
  }

  complaintAlredayRegistered(delivery: Delivery) {
    return delivery?.deliveryComplaints?.some(c => c?.expert?.id === this.selectedExpert?.id);
  }

  checkEligiblebilityForMarkToBePaid(delivery: Delivery) {
    try {
      const deliveryDeliveredAt = new Date(delivery.deliveryDeliveredAt); 
      const currentTime = new Date();
      const isMoreThan72Hours = (currentTime.getTime() - deliveryDeliveredAt.getTime()) > 72 * 60 * 60 * 1000;
      
      const approvedByPartner = delivery.service === 22 ? delivery.approvedTimingStatus === 1 : true;
      const refundRequestApproved = delivery.refundRequest ? delivery.refundRequest.requestStatus === 'approved' : true;
      const noComplaints = delivery.deliveryComplaints.length === 0;

      /*
      if(delivery.id === 40381) {
        const deliveryData = {
          "Delivery Delivered At": deliveryDeliveredAt.toLocaleString(),
          "Current Time": currentTime.toLocaleString(),
          "Is More Than 72 Hours": isMoreThan72Hours,
          "Approved By Partner": approvedByPartner,
          "Refund Request Approved": refundRequestApproved,
          "No Complaints": noComplaints
        };
        console.table([deliveryData]);
      }
      */
  
      return isMoreThan72Hours && approvedByPartner && refundRequestApproved && noComplaints;
    } catch (error) {
      console.log("ERROR_in_checkEligiblebilityForMarkToBePaid", error);
      return false;
    }
  }

  showFinancialStatus(delivery: Delivery) {
    if(delivery.paymentStatus === DeliveryPaymentStatus.default) {
      if(delivery.payable) {
        return this.checkEligiblebilityForMarkToBePaid(delivery) ? 'PAYABLE' : 'NOTPAYABLE';
      } else {
        return 'NOTPAYABLE';
      }
    } else if(delivery.paymentStatus === DeliveryPaymentStatus.toBePaid) {
      return 'TOBEPAID';
    }
  }

  async changePaymentStatus(delivery: Delivery, status: string) {
    try {
      console.log("CHANGE PAYMENT STATUS", status);
    } catch (error) {
      
    }
  }

  async handleMultipleStatusChange(paymentStatus: DeliveryPaymentStatus) {
    try {

      if (!confirm(`Tutte le consegne selezionate verranno impostate come ${paymentStatus.toUpperCase()}`)) {
        return;
      }

      let notApplicableDeliveries: Delivery[] = [];
      let excludedDeliveries: Delivery[] = [];
      let passedDeliveries: Delivery[] = [];
      let deliveryIds: any;
      let totalAmountForDeliveries: number;

      if(paymentStatus === DeliveryPaymentStatus.toBePaid) {
        notApplicableDeliveries = this.selectedDeliveries.filter(
          (delivery) =>
            delivery.status !== DeliveryStatus.delivered &&
          delivery.status !== DeliveryStatus.deliveredWithTimeToBeApproved
        );
        
        const remainingDeliveries: Delivery[] = this.selectedDeliveries.filter(
          (delivery) => !notApplicableDeliveries.some(d => d.id === delivery.id)
        );
        
        passedDeliveries = remainingDeliveries.filter(
          (delivery) => this.checkEligiblebilityForMarkToBePaid(delivery)
        );
        
        excludedDeliveries = remainingDeliveries.filter(
          (delivery) => !this.checkEligiblebilityForMarkToBePaid(delivery)
        );

        if(notApplicableDeliveries.length > 0 || excludedDeliveries.length > 0) {
          let ref = this.dialog.open(ShowInfoModalComponent, 
            { 
              width: '50vw', data: {
                notApplicableDeliveries,
                excludedDeliveries
              } 
            }
          );
          ref.afterClosed().subscribe(async (result) => {});
        }

        passedDeliveries = passedDeliveries.filter(
          (delivery) => delivery.paymentStatus === DeliveryPaymentStatus.default
        );

        deliveryIds = passedDeliveries.map(delivery => ({ id: delivery.id, totalAmount: this.commanForValues(delivery).totale }));
        totalAmountForDeliveries = this.generateAmount(passedDeliveries);
      } else {

        notApplicableDeliveries = this.selectedDeliveries.filter(
          (delivery) =>
            delivery.status !== DeliveryStatus.delivered &&
            delivery.status !== DeliveryStatus.deliveredWithTimeToBeApproved
        );

        passedDeliveries = this.selectedDeliveries.filter(
          (delivery) => !notApplicableDeliveries.some(d => d.id === delivery.id)
        );

        if(notApplicableDeliveries.length > 0) {
          let ref = this.dialog.open(ShowInfoModalComponent, 
            { 
              width: '50vw', data: {
                notApplicableDeliveries,
              } 
            }
          );
          ref.afterClosed().subscribe(async (result) => {});
        }

        passedDeliveries = passedDeliveries.filter(
          (delivery) => delivery.paymentStatus === DeliveryPaymentStatus.toBePaid
        );

        deliveryIds = passedDeliveries.map(delivery => ({ id: delivery.id, totalAmount: this.commanForValues(delivery).totale }));
        totalAmountForDeliveries = this.generateAmount(passedDeliveries);
      }

      /*
      console.log("ALL SELECTED DELIVERIES", this.selectedDeliveries);
      console.log("DELIVERIES WITHOUT DELIVERED STATUS", notApplicableDeliveries);
      console.log("REMAINING DELIVERIES", remainingDeliveries);
      console.log('PASSED DELIVERIES', passedDeliveries);
      console.log('EXCLUDED DELIVERIES', excludedDeliveries);
      */

      if((notApplicableDeliveries.length > 0 || excludedDeliveries.length > 0) && paymentStatus === DeliveryPaymentStatus.toBePaid) {
        return false;
      } 

      if(notApplicableDeliveries.length > 0) {
        return false;
      }

      this.spinnerService.show();
      let data = {
        paymentStatus: paymentStatus,
        deliveryIds: deliveryIds,
        totalAmountForDeliveries: totalAmountForDeliveries
      }

      if(deliveryIds.length <= 0) {
        this.spinnerService.hide();
        return false;
      }
      let promise = await this.deliveriesService.updateDeliveryPaymentStatus(data);
      let creditAmount: number;
      let result: { amount: number } = await this.transactionsService.getCreditAmount(this.selectedExpert.id);
      creditAmount = result.amount;
      
      if(promise?.id) {
        this.showSnackBar("Payment Status Has Been Updated");
        this.expertService.updateExpertWalletAmount(creditAmount || 0);
        await this.loadDeliveries();
      }
      this.selectedDeliveries = [];
      this.spinnerService.hide();

    } catch (error) {
      this.spinnerService.hide();
      console.log("ERROR_IN_handleMultipleStatusChange", error);
    }
  }


  deliveryPaymentStatusClass(delivery: Delivery) {
    if(delivery.paymentStatus === DeliveryPaymentStatus.default) {
      if(delivery.payable) {
        return this.checkEligiblebilityForMarkToBePaid(delivery) ? 'payable-chip' : 'not-payable-chip';
      } else {
        return 'not-payable-chip';
      }
    } else if(delivery.paymentStatus === DeliveryPaymentStatus.paid) {
      return 'paid-chip';
    } else if(delivery.paymentStatus === DeliveryPaymentStatus.toBePaid) {
      return 'to-be-paid-chip'
    }
  }

  generateAmount(deliveries: Delivery[]){
    let totalAmount = 0;
    deliveries.forEach((delivery) => {
      const values = this.commanForValues(delivery);
      if(delivery.payable) {
        totalAmount += values.totale;
      }
    });
    return totalAmount;
  }

  async exportExpertSalary() {
    try {
      if (!this.selectedDeliveries.length) {
        this.commanUsesService.showSnackBar('Seleziona prima le consegne');
        return;
      }

      const data = this.selectedDeliveries.map((d) => {
        try {
          const totals = this.commanForValues(d);

          return {
            'STATO': d?.status || 'N/A',
            'PAYMENT STATO': d?.paymentStatus || 'N/A',
            'ID VENDITA': d?.ddtNumber || 'N/A',
            'ID CONSEGNA': d?.id || 'N/A',
            'DATA': d?.deliveryDate
              ? new Date(d.deliveryDate).toLocaleDateString('it-IT')
              : 'N/A',
            'ORARIO': (d?.fromTime && d?.toTime)
              ? `${d.fromTime} ${d.toTime}`
              : 'N/A',
            'PARTNER': d?.partner?.businessName || 'N/A',
            'VALET': d?.expert?.user
              ? `${d.expert.user.surname || ''} ${d.expert.user.name || ''}`.trim()
              : 'N/A',
            'INDIRIZZO': d?.address || 'N/A',
            'ORA RITIRO': d?.pickUpTime || 'N/A',
            'SERVIZIO TYPE': d?.serviceType || 'N/A',

            'DA PAGARE': d.payable ? "YES" : "NO",
            'REFUND DATA': d?.refundRequest?.createdAt
              ? new Date(d.refundRequest.createdAt).toLocaleDateString('it-IT')
              : 'N/A',
            'REFUND PLUS': totals.refundPlus.toFixed(2),
            'PREZZO': totals.prezzo.toFixed(2),
            'PLUS MINUS PREZZO': totals.plusMinusPrezzo.toFixed(2),
            'VALET SALARIO': totals.valetSalary.toFixed(2),
            'PLUS MINUS SALARIO': totals.valetPlusMinusSalary.toFixed(2),
            'INCASSI CONTANTI': (d.payAtDeliveryAmount || 0).toFixed(2),
            'TOTALE': totals.totale.toFixed(2)
          };

        } catch (rowError) {
          console.error('Row error:', d, rowError);

          return {
            'STATO': 'ERRORE',
            'PAYMENT STATO': 'N/A',
            'ID VENDITA': d?.ddtNumber || 'N/A',
            'ID CONSEGNA': d?.id || 'N/A',
            'DATA': 'N/A',
            'ORARIO': 'N/A',
            'PARTNER': 'N/A',
            'EXPERT': 'N/A',
            'INDIRIZZO': 'N/A',
            'ORA RITIRO': 'N/A',
            'SERVIZIO TYPE': 'N/A',
            'DA PAGARE': '0.00 €',
            'REFUND DATA': 'N/A',
            'REFUND PLUS': '0.00 €',
            'PREZZO': '0.00 €',
            'PLUS MINUS PREZZO': '0.00 €',
            'VALET SALARIO': '0.00 €',
            'PLUS MINUS SALARIO': '0.00 €',
            'INCASSI CONTANTI': '0.00 €',
            'TOTALE': '0.00 €'
          };
        }
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Valet Stipendi': worksheet },
        SheetNames: ['Valet Stipendi']
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const blob: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });

      saveAs(blob, 'Valet_Stipendi.xlsx');

    } catch (error) {
      console.error('EXPORT ERROR:', error);
      this.commanUsesService.showSnackBar(
        'Errore durante esportazione stipendio expert'
      );
    }
  }

  handleModalBox(deliveryId?: number) {
    if (deliveryId) {
      this.selectedDelivery =
        this.deliveries.find(d => d.id === deliveryId) || null;

      this.additionalValetPlusMinus = this.selectedDelivery.additionalValetPlusMinus || 0;
      this.showAddionalPriceValetModal = true;
    } else {
      this.showAddionalPriceValetModal = false;
      this.selectedDelivery = null;
    }
  }

  async submitAdditionalValetPlusMinus() {
    this.isSubmitting = true;
    try {
      
      const promiseResult = await this.deliveriesService.update(this.selectedDelivery.id, {
        additionalValetPlusMinus: this.additionalValetPlusMinus
      });

      await this.loadDeliveries();
      this.commanUsesService.showSnackBar('Valet additional price has been updated');
    } catch (error) {
      const errorMessage = error?.error?.message || error?.message || 'Something went wrong';
      this.commanUsesService.showSnackBar(errorMessage);
    } finally {
      this.isSubmitting = false;
      this.showAddionalPriceValetModal = false;
      this.selectedDelivery = null;
      this.additionalValetPlusMinus = null;
    }
  }

}
